export const SLIDER_EVENTS = {
  UPDATE: 'update-auto-height',
  AUTOPLAY: 'autoplay',
  NEXT_SLIDE: 'next-slide',
  PREV_SLIDE: 'prev-slide',
};
